import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["priceCard", "mapMarker"]
  static values = {
    searchId: Number,
    priceId: Number,
    pharmacyLocationId: Number,
    eventType: String,
    targetUrl: String
  }

  track(event) {
    const element = event.currentTarget
    const payload = this.payloadFrom(element)
    if (!payload.search_id || !payload.event_type) return

    this.send(payload)
  }

  payloadFrom(element) {
    const data = element.dataset
    return {
      search_id: this.integerValue(data.clicksSearchIdValue || this.optionalValue("searchId")),
      event_type: data.clicksEventTypeValue || this.optionalValue("eventType"),
      price_id: this.integerValue(data.clicksPriceIdValue || this.optionalValue("priceId")),
      pharmacy_location_id: this.integerValue(data.clicksPharmacyLocationIdValue || this.optionalValue("pharmacyLocationId")),
      target_url: data.clicksTargetUrlValue || this.optionalValue("targetUrl") || element.href || null
    }
  }

  send(payload) {
    const body = JSON.stringify(this.compact(payload))

    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" })
      navigator.sendBeacon("/clicks", blob)
      return
    }

    fetch("/clicks", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
      credentials: "same-origin"
    }).catch(() => {})
  }

  compact(object) {
    return Object.fromEntries(
      Object.entries(object).filter(([, value]) => value !== null && value !== undefined && value !== "")
    )
  }

  integerValue(value) {
    if (value === null || value === undefined || value === "") return null

    const integer = parseInt(value, 10)
    return Number.isNaN(integer) ? null : integer
  }

  optionalValue(name) {
    const hasValueName = `has${name.charAt(0).toUpperCase()}${name.slice(1)}Value`
    return this[hasValueName] ? this[`${name}Value`] : null
  }
}
